__turbopack_context__.v({
  "className": "_3aBkjW_className",
  "variable": "_3aBkjW_variable",
});
